import { useDialog } from '@/hooks/useDialog';
import { Fragment } from 'react';

export const DialogContainer = () => {
  const { dialogState } = useDialog();

  return (
    <>
      {dialogState.map((state) => (
        <Fragment key={state.id}>{state.view}</Fragment>
      ))}
    </>
  );
};
